export default __webpack_public_path__ + "8bc6a81cc1e71e9a3dee9fe43dcee75a.png";